export const ActionTypes = {
  LOADING: "DELETE_COLLABORATORS_LOADING",
  ERROR: "DELETE_COLLABORATORS_ERROR",
  SUCCESS: "DELETE_COLLABORATORS_SUCCESS",
};
